export default {
  disabled: {
    title: 'La facturación no se gestiona en la plataforma',
    description:
      'Las suscripciones y facturas no están disponibles porque la facturación entre tú y tus restaurantes se liquida fuera de la plataforma. Los pagos, extractos e informes siguen disponibles.',
  },
};
